var script =
    '<xml><block type="maze_step_unstart" class="inline maze_step_unstart" id="32" x="20" y="22" movable="false" deletable="false"></block></xml>';

var EBS2015DATA = {};

EBS2015DATA.config = {
    '1-1': {
        gridSize: {
            width: 7,
            height: 5,
        },
        theme: 'ebs2015',
        playerType: 'soffy',
        tileSize: 68,
        bitmapPath: '/legacy_img/assets/ntry/bitmap/ebs_2015_1/',
        availableBlocks: ['ebs2015_maze_move_step'],
        intro: {
            content: '소피야, 도움이 필요해! 우리집으로 좀 와줘!',
        },
        hint: {
            title: ' 소피가 집까지 갈 수 있게 도와주세요.',
            content: '명령어 블록들을 순서대로 조립해서 소피가 집까지 갈 수 있게 도와주세요.',
        },
    },
    '1-2': {
        gridSize: {
            width: 7,
            height: 5,
        },
        theme: 'ebs2015',
        playerType: 'soffy',
        tileSize: 68,
        bitmapPath: '/legacy_img/assets/ntry/bitmap/ebs_2015_1/',
        availableBlocks: ['ebs2015_maze_move_step', 'maze_step_rotate'],
        intro: {
            content:
                '소피야, 집에 도착했니? <br>식탁 위에 점심 도시락을 두고왔어. 학교로 도시락 좀 가져다 줘~',
        },
        hint: {
            title: ' 소피가 학교까지 갈 수 있게 도와주세요.',
            content:
                '명령어 블록을 순서대로 조립해서 소피가 학교까지 갈 수 있게 도와주세요.<br><br>어느 길로 가든 소피가 학교에 도착하기만 하면 됩니다.',
        },
    },
    '1-3': {
        gridSize: {
            width: 7,
            height: 5,
        },
        theme: 'ebs2015',
        playerType: 'soffy',
        tileSize: 68,
        bitmapPath: '/legacy_img/assets/ntry/bitmap/ebs_2015_1/',
        availableBlocks: ['ebs2015_maze_move_step', 'maze_step_rotate', 'maze_step_jump'],
        intro: {
            content:
                '소피야 고마워! 점심 맛있게 먹을게!<br>가는 길에 과일가게에서 사과 좀 사다가 할머니댁에 갖다드려줘!<br>곳곳에 공사중인 곳들을 잘 뛰어넘어야 해!',
        },
        hint: {
            title: ' 소피가 과일가게에서 사과를 사다가 할머니 댁으로 갈 수 있게 도와주세요.',
            content:
                '명령어 블록을 순서대로 조립해서 과일가게에 갔다가 할머니 댁으로 갈 수 있게 도와주세요.<br><br>어느 길로 가든 소피가 순서대로 과일가게와 할머니댁에 도착하면 됩니다.<br>하지만 공사중인 곳을 만나면 꼭 뛰어넘어야겠죠?',
        },
    },
    '2-1': {
        gridSize: {
            width: 7,
            height: 5,
        },
        theme: 'ebs2015',
        playerType: 'soffy',
        tileSize: 68,
        bitmapPath: '/legacy_img/assets/ntry/bitmap/ebs_2015_1/',
        availableBlocks: ['ebs2015_maze_move_step', 'maze_step_rotate', 'maze_step_ebs_for'],
        intro: {
            content: '소피야~ 놀자! 지금 학교로 올래?',
        },
        essentialBlockInfo: {
            matchCnt: 1,
            blocks: ['maze_step_for'],
        },
        hint: {
            title: ' 소피가 학교로 갈 수 있게 도와주세요.',
            content:
                "반복 블록을 사용하여 소피가 학교까지 쉽게 갈 수 있도록 도와주세요.<br><br>반복 블록으로 명령 블록들을 감싸고, '(~)회 반복하기' 블록 안의 숫자를 바꾸어주면 원하는 횟수만큼 명령을 반복할 수 있어요!",
        },
    },
    '2-2': {
        gridSize: {
            width: 7,
            height: 5,
        },
        theme: 'ebs2015',
        playerType: 'soffy',
        tileSize: 68,
        bitmapPath: '/legacy_img/assets/ntry/bitmap/ebs_2015_2/',
        availableBlocks: ['ebs2015_maze_move_step', 'maze_step_rotate', 'maze_step_ebs_for'],
        intro: {
            content: '소피야~ 학교에 도착했니? 그럼 우리교실로 와~',
        },
        essentialBlockInfo: {
            matchCnt: 1,
            blocks: ['maze_step_for'],
        },
        hint: {
            title: ' 소피가 복도를 지나 교실까지 갈 수 있도록 도와주세요.',
            content:
                "반복 블록을 사용하여 소피가 교실까지 도착할 수 있도록 도와주세요.<br><br>반복 블록으로 명령 블록들을 감싸고, '(~)회 반복하기' 블록 안의 숫자를 바꾸어주면 원하는 횟수만큼 명령을 반복할 수 있어요!<br><br>소피가 똑같이 반복해야 하는 명령은 무엇일까요?",
        },
    },
    '2-3': {
        gridSize: {
            width: 7,
            height: 5,
        },
        theme: 'ebs2015',
        playerType: 'soffy',
        tileSize: 68,
        bitmapPath: '/legacy_img/assets/ntry/bitmap/ebs_2015_2/',
        availableBlocks: [
            'ebs2015_maze_move_step',
            'maze_step_rotate',
            'maze_step_jump',
            'ebs2015_maze_while_true_1',
        ],
        intro: {
            content:
                '소피, 왔구나! 기다리고있었어~<br>우린 장애물 뛰어넘기 게임을 할 거야!<br>바닥의 가방을 뛰어넘으며 깃발까지 가 보자!',
        },
        essentialBlockInfo: {
            matchCnt: 1,
            blocks: ['ebs2015_maze_while_true_1'],
        },
        hint: {
            title: ' 소피가 깃발까지 무사히 갈 수 있게 도와주세요.',
            content:
                "반복 블록을 사용하여 소피가 깃발까지 무사히 갈 수 있게 도와주세요.<br><br>'~까지 반복' 블록을 사용하면 조건을 만족할 때까지 감싸고 있는 명령들을 반복한답니다!<br><br>소피가 똑같이 반복해야 하는 명령은 무엇일까요?",
        },
    },
    '2-4': {
        gridSize: {
            width: 7,
            height: 5,
        },
        theme: 'ebs2015',
        playerType: 'soffy',
        tileSize: 68,
        bitmapPath: '/legacy_img/assets/ntry/bitmap/ebs_2015_3/',
        availableBlocks: [
            'ebs2015_maze_move_step',
            'maze_step_rotate',
            'ebs2015_maze_repeat_until_1',
        ],
        intro: {
            content: '소피! 이번에는 보물찾기 게임이야!<br>3개의 보물을 모두 찾으면 돼!',
        },
        essentialBlockInfo: {
            matchCnt: 1,
            blocks: ['ebs2015_maze_repeat_until_1'],
        },
        hint: {
            title: ' 소피가 3개의 보물을 모두 찾을 수 있게 도와주세요.',
            content:
                "반복 블록을 사용하여 소피가 3개의 보물을 모두 찾을 수 있게 도와주세요.<br><br>'~까지 반복' 블록을 사용하면 조건을 만족할 때까지 감싸고 있는 명령들을 반복한답니다!<br><br>소피가 똑같이 반복해야 하는 명령은 무엇일까요?",
        },
    },
    '3-1': {
        gridSize: {
            width: 7,
            height: 5,
        },
        theme: 'ebs2015',
        playerType: 'soffy',
        tileSize: 68,
        bitmapPath: '/legacy_img/assets/ntry/bitmap/ebs_2015_3/',
        availableBlocks: [
            'ebs2015_maze_move_step',
            'maze_step_rotate',
            'ebs2015_maze_while_true_1',
            'ebs2015_maze_if_wall',
        ],
        intro: {
            content:
                '소피! 미로찾기 공원에 온 걸 환영해!<br><br>미로를 탈출해 깃발까지 가면 되는데... 어떤 상황에서 어떻게 움직여야 할 지, 잘 생각해봐!',
        },
        essentialBlockInfo: {
            matchCnt: 2,
            blocks: ['ebs2015_maze_while_true_1', 'ebs2015_maze_if_wall'],
        },
        hint: {
            title: ' 소피가 미로를 탈출할 수 있게 도와주세요.',
            content:
                '만약 ~라면 블록을 사용하여 소피가 무사히 미로를 탈출할 수 있게 도와주세요.<br><br>앞으로 가다가 벽을 만나면 어떻게 해야 할까요?<br><br>어떤 상황에서 어떻게 움직여야 할 지 잘 생각해보세요!',
        },
    },
    '3-2': {
        gridSize: {
            width: 7,
            height: 5,
        },
        theme: 'ebs2015',
        playerType: 'soffy',
        tileSize: 68,
        bitmapPath: '/legacy_img/assets/ntry/bitmap/ebs_2015_3/',
        availableBlocks: [
            'ebs2015_maze_move_step',
            'maze_step_rotate',
            'maze_step_jump',
            'ebs2015_maze_while_true_1',
            'ebs2015_maze_if_wall',
            'maze_step_if_2',
        ],
        intro: {
            content:
                '이번엔 곳곳에 벌집이 있잖아?<br>벌에 쏘이지 않으려면 벌집을 조심조심 뛰어 넘어면서 미로를 탈출해야 해!',
        },
        essentialBlockInfo: {
            matchCnt: 2,
            blocks: ['ebs2015_maze_while_true_1', 'ebs2015_maze_if_wall', 'maze_step_if_2'],
        },
        hint: {
            title: ' 소피가 미로를 탈출할 수 있게 도와주세요.',
            content:
                '만약 ~라면 블록을 사용하여 소피가 무사히 미로를 탈출할 수 있게 도와주세요.<br><br>앞으로 가다가 벽을 만나면 어떻게 해야 할까요?<br>앞으로 가다가 벌집을 만나면 어떻게 해야 할까요?<br><br>어떤 상황에서 어떻게 움직여야 할 지 잘 생각해보세요!',
        },
    },
    '3-3': {
        gridSize: {
            width: 7,
            height: 5,
        },
        theme: 'ebs2015',
        playerType: 'soffy',
        tileSize: 68,
        bitmapPath: '/legacy_img/assets/ntry/bitmap/ebs_2015_3/',
        availableBlocks: [
            'ebs2015_maze_move_step',
            'maze_step_rotate',
            'ebs2015_maze_while_true_1',
            'ebs2015_maze_if_else_notice',
        ],
        intro: {
            content:
                '이번엔 친절하게 표지판이 있네?<br>표지판이 없을때와 있을 때, 어떻게 하면 미로를 탈출할 수 있을까?',
        },
        essentialBlockInfo: {
            matchCnt: 2,
            blocks: ['ebs2015_maze_while_true_1', 'ebs2015_maze_if_else_notice'],
        },
        hint: {
            title: ' 소피가 미로를 탈출할 수 있게 도와주세요.',
            content:
                '만약 ~라면 / 아니면 블록을 사용하여 소피가 무사히 미로를 탈출할 수 있게 도와주세요.<br><br>앞에 표지판이 있다면 어떻게 해야 할까요?<br>표지판이 없을 때에는 어떻게 해야 할까요?<br><br>조건을 만족할 때와 아닐 때, 어떻게 움직여야 할 지 잘 생각해보세요!',
        },
    },
    '3-4': {
        gridSize: {
            width: 7,
            height: 5,
        },
        theme: 'ebs2015',
        playerType: 'soffy',
        tileSize: 68,
        bitmapPath: '/legacy_img/assets/ntry/bitmap/ebs_2015_3/',
        availableBlocks: [
            'ebs2015_maze_move_step',
            'maze_step_rotate',
            'ebs2015_maze_while_true_1',
            'ebs2015_maze_if_else_wall',
            'ebs2015_maze_if_else_notice',
        ],
        intro: {
            content:
                '앞으로 가다가 숲을 만났을 때와 표지판을 만났을 때, 어떻게 움직여야 어떻게 하면 미로를 탈출할 수 있을까?',
        },
        essentialBlockInfo: {
            matchCnt: 2,
            blocks: [
                'ebs2015_maze_while_true_1',
                'ebs2015_maze_if_else_wall',
                'ebs2015_maze_if_else_notice',
            ],
        },
        hint: {
            title: ' 소피가 미로를 탈출할 수 있게 도와주세요.',
            content:
                '만약 ~라면 / 아니면 블록을 사용하여 소피가 무사히 미로를 탈출할 수 있게 도와주세요.<br><br>만약 ~라면 / 아니면 블록 안에 만약 ~라면 / 아니면 블록을 또 넣으면 여러가지 상황에 다르게 행동하도록 만들 수 있어요.<br><br>앞에 벽이 있다면 어떻게 해야 할까요?<br>아니면 앞에 표지판이 있다면 어떻게 해야 할까요?<br>그것도 아니라면 어떻게 움직여야 할까요?<br><br>여러 가지 상황에서 어떻게 움직여야 할 지 잘 생각하며 블록을 조립해 보세요!',
        },
    },
};

// Generate tile entities. wall and road only.

EBS2015DATA.tileMap = {
    '1-1': [
        ['wall_15', 'wall_16', 'wall_17', 'wall_18', 'wall_19', 'wall_14', 'wall_21'],
        ['wall_01', 'wall_11', 'wall_09', 'wall_07', 'wall_03', 'wall_13', 'wall_03'],
        ['wall_11', 'road_04', 'road_03', 'road_05', 'road_02', 'road_02', 'wall_03'],
        ['wall_11', 'wall_12', 'wall_04', 'wall_07', 'wall_05', 'wall_11', 'wall_06'],
        ['wall_11', 'wall_09', 'wall_07', 'wall_01', 'wall_04', 'wall_08', 'wall_05'],
    ],
    '1-2': [
        ['wall_11', 'wall_12', 'wall_04', 'wall_07', 'wall_05', 'wall_11', 'wall_06'],
        ['wall_11', 'road_04', 'road_03', 'road_05', 'road_02', 'road_02', 'wall_03'],
        ['road_04', 'road_04', 'wall_03', 'wall_05', 'wall_02', 'road_02', 'road_05'],
        ['wall_11', 'road_04', 'road_03', 'road_05', 'road_02', 'road_02', 'wall_03'],
        ['wall_11', 'wall_09', 'wall_07', 'wall_01', 'wall_04', 'wall_08', 'wall_05'],
    ],
    '1-3': [
        ['wall_11', 'wall_12', 'wall_13', 'wall_07', 'wall_05', 'wall_11', 'wall_06'],
        ['wall_11', 'road_04', 'road_03', 'road_05', 'road_02', 'road_02', 'wall_03'],
        ['road_04', 'road_04', 'road_04', 'road_05', 'road_02', 'road_02', 'wall_05'],
        ['wall_11', 'road_04', 'road_03', 'road_05', 'road_02', 'road_02', 'wall_03'],
        ['wall_11', 'road_04', 'road_03', 'road_01', 'road_04', 'road_05', 'wall_05'],
    ],
    '2-1': [
        ['wall_20', 'wall_21', 'wall_15', 'wall_16', 'wall_17', 'wall_18', 'wall_19'],
        ['wall_01', 'wall_11', 'wall_09', 'wall_07', 'wall_03', 'wall_12', 'wall_03'],
        ['wall_11', 'road_04', 'road_03', 'road_05', 'road_02', 'road_02', 'road_03'],
        ['wall_11', 'wall_12', 'wall_04', 'wall_07', 'wall_05', 'wall_11', 'wall_06'],
        ['wall_11', 'wall_09', 'wall_07', 'wall_01', 'wall_04', 'wall_08', 'wall_05'],
    ],
    '2-2': [
        ['wall_08', 'wall_04', 'wall_05', 'wall_02', 'wall_03', 'road_01', 'wall_02'],
        ['wall_01', 'wall_03', 'wall_02', 'wall_03', 'road_03', 'road_04', 'wall_03'],
        ['wall_01', 'wall_02', 'wall_03', 'road_04', 'road_02', 'wall_03', 'wall_03'],
        ['wall_02', 'wall_03', 'road_04', 'road_02', 'wall_02', 'wall_02', 'wall_02'],
        ['wall_01', 'road_03', 'road_01', 'wall_03', 'wall_01', 'wall_03', 'wall_01'],
    ],
    '2-3': [
        ['wall_08', 'road_04', 'road_03', 'road_01', 'road_02', 'road_03', 'wall_06'],
        ['wall_01', 'wall_03', 'wall_03', 'wall_01', 'wall_01', 'road_04', 'wall_07'],
        ['wall_02', 'wall_02', 'wall_02', 'wall_02', 'wall_02', 'road_03', 'wall_03'],
        ['wall_03', 'wall_03', 'wall_01', 'wall_01', 'wall_03', 'road_02', 'wall_06'],
        ['wall_01', 'road_03', 'road_01', 'road_03', 'road_01', 'road_03', 'wall_07'],
    ],
    '2-4': [
        ['wall_04', 'road_15', 'road_03', 'road_03', 'road_16', 'wall_04', 'wall_04'],
        ['wall_04', 'road_02', 'road_13', 'road_13', 'road_01', 'wall_04', 'wall_04'],
        ['wall_04', 'road_02', 'road_13', 'road_13', 'road_01', 'wall_04', 'wall_04'],
        ['wall_03', 'road_17', 'road_04', 'road_04', 'road_18', 'wall_04', 'wall_04'],
        ['wall_01', 'wall_02', 'wall_04', 'wall_04', 'wall_04', 'wall_04', 'wall_04'],
    ],
    '3-1': [
        ['wall_07', 'wall_05', 'wall_08', 'wall_06', 'wall_05', 'wall_08', 'wall_07'],
        ['wall_05', 'road_05', 'road_09', 'road_09', 'road_09', 'road_06', 'wall_06'],
        ['wall_07', 'road_10', 'wall_07', 'wall_08', 'wall_05', 'road_12', 'wall_07'],
        ['wall_06', 'road_10', 'wall_05', 'wall_07', 'wall_07', 'road_12', 'wall_08'],
        ['wall_08', 'road_10', 'wall_06', 'road_11', 'road_11', 'road_08', 'wall_05'],
    ],
    '3-2': [
        ['wall_06', 'wall_07', 'wall_05', 'wall_08', 'wall_07', 'wall_06', 'wall_06'],
        ['wall_07', 'road_15', 'road_11', 'road_11', 'road_11', 'road_06', 'wall_08'],
        ['wall_06', 'road_10', 'wall_07', 'wall_08', 'wall_05', 'road_10', 'wall_05'],
        ['wall_05', 'road_10', 'wall_05', 'wall_07', 'wall_07', 'wall_05', 'wall_07'],
        ['wall_07', 'road_07', 'road_11', 'road_11', 'road_11', 'road_11', 'wall_06'],
    ],
    '3-3': [
        ['wall_05', 'road_19', 'wall_05', 'wall_07', 'wall_07', 'wall_05', 'wall_06'],
        ['road_11', 'road_03', 'road_09', 'road_09', 'wall_07', 'wall_08', 'wall_07'],
        ['wall_05', 'road_12', 'wall_07', 'wall_08', 'wall_05', 'wall_06', 'wall_05'],
        ['road_19', 'road_02', 'road_11', 'road_11', 'road_11', 'road_11', 'wall_06'],
        ['wall_07', 'road_10', 'wall_07', 'wall_05', 'wall_07', 'wall_08', 'wall_05'],
    ],
    '3-4': [
        ['wall_05', 'wall_06', 'wall_05', 'wall_07', 'wall_07', 'wall_05', 'wall_06'],
        ['wall_06', 'wall_05', 'road_19', 'wall_05', 'wall_08', 'wall_05', 'wall_07'],
        ['wall_05', 'wall_06', 'road_05', 'road_11', 'road_06', 'road_19', 'wall_05'],
        ['wall_07', 'wall_06', 'road_10', 'wall_07', 'road_12', 'wall_06', 'wall_06'],
        ['road_09', 'road_11', 'road_08', 'wall_05', 'road_07', 'road_11', 'road_11'],
    ],
};

EBS2015DATA.fence_front = {};

EBS2015DATA.obstacle = {
    '1-3': [
        { image: 'obstacle_02', x: 2, y: 1, type: Ntry.STATIC.OBSTACLE_SIGN },
        { image: 'obstacle_02', x: 1, y: 2, type: Ntry.STATIC.OBSTACLE_SIGN },
        { image: 'obstacle_02', x: 4, y: 2, type: Ntry.STATIC.OBSTACLE_SIGN },
        { image: 'obstacle_02', x: 5, y: 2, type: Ntry.STATIC.OBSTACLE_SIGN },
        { image: 'obstacle_02', x: 2, y: 3, type: Ntry.STATIC.OBSTACLE_SIGN },
        { image: 'obstacle_02', x: 3, y: 3, type: Ntry.STATIC.OBSTACLE_SIGN },
    ],
    '2-3': [
        { image: 'obstacle_02', x: 2, y: 0, type: Ntry.STATIC.OBSTACLE_SIGN },
        { image: 'obstacle_02', x: 4, y: 0, type: Ntry.STATIC.OBSTACLE_SIGN },
        { image: 'obstacle_02', x: 5, y: 1, type: Ntry.STATIC.OBSTACLE_SIGN },
        { image: 'obstacle_02', x: 5, y: 3, type: Ntry.STATIC.OBSTACLE_SIGN },
        { image: 'obstacle_02', x: 4, y: 4, type: Ntry.STATIC.OBSTACLE_SIGN },
        { image: 'obstacle_02', x: 2, y: 4, type: Ntry.STATIC.OBSTACLE_SIGN },
    ],
    '3-2': [
        { image: 'obstacle_01', x: 3, y: 4, type: Ntry.STATIC.OBSTACLE_BEE },
        { image: 'obstacle_01', x: 3, y: 1, type: Ntry.STATIC.OBSTACLE_BEE },
    ],
    '3-3': [
        { image: 'turn_01', x: 1, y: 0, type: Ntry.STATIC.OBSTACLE_NOTICE },
        { image: 'turn_01', x: 0, y: 3, type: Ntry.STATIC.OBSTACLE_NOTICE, rotation: 270 },
    ],
    '3-4': [
        { image: 'turn_01', x: 2, y: 1, type: Ntry.STATIC.OBSTACLE_NOTICE },
        { image: 'turn_01', x: 5, y: 2, type: Ntry.STATIC.OBSTACLE_NOTICE, rotation: 90 },
    ],
};

EBS2015DATA.player = {
    '1-1': {
        x: 1,
        y: 2,
        script,
    },
    '1-2': {
        x: 0,
        y: 2,
        script,
    },
    '1-3': {
        x: 0,
        y: 2,
        script,
    },
    '2-1': {
        x: 1,
        y: 2,
        script,
    },
    '2-2': {
        x: 1,
        y: 4,
        script,
    },
    '2-3': {
        x: 1,
        y: 0,
        script,
    },
    '2-4': {
        x: 1,
        y: 3,
        script,
    },
    '3-1': {
        x: 3,
        y: 4,
        script,
    },
    '3-2': {
        x: 5,
        y: 4,
        direction: Ntry.STATIC.WEST,
        script,
    },
    '3-3': {
        x: 5,
        y: 3,
        direction: Ntry.STATIC.WEST,
        script,
    },
    '3-4': {
        x: 0,
        y: 4,
        script,
    },
};

EBS2015DATA.goal = {
    '1-1': [{ image: 'goal_home', x: 5, y: 2 }],
    '1-2': [{ image: 'goal_school', x: 6, y: 2 }],
    '1-3': [
        { image: 'goal_fruit', x: 3, y: 1, sequence: 0 },
        { image: 'goal_grandma_home', x: 5, y: 4, sequence: 1 },
    ],
    '2-1': [{ image: 'goal_school', x: 6, y: 2 }],
    '2-2': [{ image: 'goal_01', x: 5, y: 0 }],
    '2-3': [{ image: 'goal_02', x: 1, y: 4 }],
    '2-4': [
        { image: 'goal_01', x: 1, y: 0 },
        { image: 'goal_01', x: 4, y: 0 },
        { image: 'goal_01', x: 4, y: 3 },
    ],
    '3-1': [{ image: 'goal_02', x: 1, y: 4 }],
    '3-2': [{ image: 'goal_02', x: 5, y: 2 }],
    '3-3': [{ image: 'goal_02', x: 3, y: 1 }],
    '3-4': [{ image: 'goal_02', x: 6, y: 4 }],
};

EBS2015DATA.FRAMES = {};
EBS2015DATA.FRAMES[Ntry.STATIC.STAND] = {
    north: { key: 3, frame: [0] },
    east: { key: 0, frame: [0] },
    south: { key: 2, frame: [0] },
    west: { key: 0, frame: [0], flip: true },
    next: Ntry.STATIC.STAND,
    movement: 0,
};
EBS2015DATA.FRAMES[Ntry.STATIC.WALK] = {
    north: { key: 3, frame: [0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2] },
    east: { key: 0, frame: [0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2] },
    south: { key: 2, frame: [0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2] },
    west: { key: 1, frame: [0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2] },
    next: Ntry.STATIC.STAND,
    movement: 1,
    gridMovement: 1,
};
EBS2015DATA.FRAMES[Ntry.STATIC.JUMP] = {
    north: { key: 7, frame: _.range(0, 11) },
    east: { key: 4, frame: _.range(0, 9) },
    south: { key: 6, frame: _.range(0, 11) },
    west: { key: 5, frame: _.range(0, 9) },
    next: Ntry.STATIC.STAND,
    movement: 2,
    gridMovement: 2,
};
EBS2015DATA.FRAMES[Ntry.STATIC.TURN_RIGHT] = {
    north: { key: 3, frame: [0] },
    east: { key: 0, frame: [0] },
    south: { key: 2, frame: [0] },
    west: { key: 0, frame: [0], flip: true },
    next: Ntry.STATIC.STAND,
    rotation: 1,
    movement: 0,
};
EBS2015DATA.FRAMES[Ntry.STATIC.TURN_LEFT] = {
    north: { key: 3, frame: [0] },
    east: { key: 0, frame: [0] },
    south: { key: 2, frame: [0] },
    west: { key: 0, frame: [0], flip: true },
    next: Ntry.STATIC.STAND,
    rotation: -1,
    movement: 0,
};
EBS2015DATA.FRAMES[Ntry.STATIC.BEE_ATTACK] = EBS2015DATA.FRAMES[Ntry.STATIC.WALL_CRASH] = {
    north: { key: 3, frame: [0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2] },
    east: { key: 0, frame: [0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2] },
    south: { key: 2, frame: [0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2] },
    west: { key: 1, frame: [0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2] },
    next: Ntry.STATIC.FAIL,
    movement: -0.2,
};
EBS2015DATA.FRAMES[Ntry.STATIC.SIMOOROOK] = {
    north: { key: 3, frame: [0] },
    east: { key: 0, frame: [0] },
    south: { key: 2, frame: [0] },
    west: { key: 0, frame: [0], flip: true },
    next: Ntry.STATIC.FAIL,
    movement: 0,
};
EBS2015DATA.FRAMES[Ntry.STATIC.SEQUENCE_SIMOOROOK] = EBS2015DATA.FRAMES[Ntry.STATIC.SIMOOROOK];
EBS2015DATA.FRAMES[Ntry.STATIC.STOP] = {};
